import {kSystemIcons} from "../../../constants/icons";

export default function BrevetFiltersHeader({handleClose}) {
    // Used in BrevetFiltersDialog to display dialog header made of
    // title and closing icon

    // BUILD
    return (
        <div className={"w-full flex justify-between items-start space-x-[12px] px-[16px] py-[12px] border-b-[1px] border-greyLight5 bg-gradient-to-br from-backgroundLight3 to-backgroundLight1"}>
            <div className={"flex justify-start items-center space-x-[16px]"}>
                <div className={"flex justify-center items-center rounded-[8px] bg-greenStar/30 w-[32px] min-w-[32px] h-[32px] min-h-[32px]"}>
                    <i className="material-icons text-[16px] text-greenStar">
                        {kSystemIcons.filter}
                    </i>
                </div>
                <span className={"font-bold text-[14px] text-white"}>
                    {"Filtres"}
                </span>
            </div>
            <div className={"flex mt-[4px]"}
                 onClick={handleClose}>
                <i className={`material-icons cursor-pointer text-[24px] text-greyLight7 hover:text-greyLight9`}>
                    {kSystemIcons.cancel}
                </i>
            </div>
        </div>
    );
}